import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { MainInboxComponent } from '@main/inbox/main-inbox.component';
import { TenantDataService } from '@services/data/tenant-data.service';

@Component({
    templateUrl: './main-inbox.page.component.html',
    styleUrl: './main-inbox.page.component.scss',
    imports: [MainInboxComponent, AsyncPipe],
})
export class MainInboxPageComponent {
    private readonly tenantDataService = inject(TenantDataService);

    currentTenant$ = this.tenantDataService.currentTenant$;
}
